module.exports={
  "en": {
    "name": "Global Accessibility Awareness Day (GAAD)",
    "before": "Join us on Thursday May {d}{th}, {y} and mark the {x}th <a {at}>{g}</a>.",
    "after": "Put next year's <a {at}>{g}</a>, Thursday May {d}{th}, {y}, in your diary. See you then!",
    "put": "Put gaad-widget on your web site",
    "ical": "Download an iCal calendar file",
    "url": "https://accessibility.day"
  },
  "es": {
    "name": "Día Mundial para Promover la Concienciación sobre la Accesibilidad Web (GAAD)",
    "before": "El {d} de mayo de {y}, le invitamos a participar en el {x} ° <a {at}>{g}</a>.",
    "after": "Coloque el <a {at}>{g}<a> del próximo año, el jueves {d} de mayo de {y}, en su diario. ¡Hasta entonces!",
    "url": "/espanol/"
  },
  "fr": {
    "name": "Journée Mondiale de Sensibilisation à l'Accessibilité (GAAD)",
    "before": "Rejoignez-nous le jeudi {d} mai {y} et marquez le {x}ème <a {at}>{g}</a>.",
    "after": "Mettez le <a {at}>{g}</a> de l'année prochaine, le jeudi {d} mai {y} dans votre journal. À plus tard!",
    "put": "Mettez 'gaad-widget' sur votre site web",
    "ical": "Télécharger un fichier de calendrier (iCal)",
    "url": "/francais/"
  },
  "zh-cn": {
    "name": "国际残疾人网上科技使用活动日 (GAAD)",
    "before": "欢迎在每年5月份的第三个星期四加入我们，— <a {at}>{g}</a>。",
    "after": "请在您的日历上标注5月  日举行的活动日 — <a {at}>{g}</a>。",
    "ical": "下载 iCal 日历文件",
    "url": "/"
  }
}